import React, { useState, useEffect, useRef } from 'react';
import { FaBell } from 'react-icons/fa';
import axios from 'axios';
import '../styles/NotificationBell.css';

const API = process.env.REACT_APP_API_URL || '';

function NotificationBell() {
  const [notifications, setNotifications] = useState([]);
  const [unread, setUnread] = useState(0);
  const [open, setOpen] = useState(false);
  const ref = useRef();

  useEffect(() => {
    loadCount();
    const interval = setInterval(loadCount, 30000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const handleClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const loadCount = async () => {
    try {
      const res = await axios.get(`${API}/api/notifications/count`);
      setUnread(res.data.count);
    } catch (e) { /* ignore */ }
  };

  const loadAll = async () => {
    try {
      const res = await axios.get(`${API}/api/notifications?limit=20`);
      setNotifications(res.data);
    } catch (e) { /* ignore */ }
  };

  const toggle = () => {
    if (!open) loadAll();
    setOpen(!open);
  };

  const markRead = async (id) => {
    try {
      await axios.put(`${API}/api/notifications/${id}/read`);
      setNotifications(notifications.map(n => n.id === id ? {...n, is_read: 1} : n));
      setUnread(Math.max(0, unread - 1));
    } catch (e) { /* ignore */ }
  };

  const markAllRead = async () => {
    try {
      await axios.put(`${API}/api/notifications/read-all`);
      setNotifications(notifications.map(n => ({...n, is_read: 1})));
      setUnread(0);
    } catch (e) { /* ignore */ }
  };

  const formatDate = (d) => {
    const diff = Date.now() - new Date(d).getTime();
    if (diff < 3600000) return `${Math.floor(diff/60000)}min`;
    if (diff < 86400000) return `${Math.floor(diff/3600000)}h`;
    return new Date(d).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' });
  };

  const typeIcons = { new_album: '💿', comment_reply: '💬', listening_party: '🎧', system: '🔔' };

  return (
    <div className="notif-bell-container" ref={ref}>
      <button className="notif-bell-btn" onClick={toggle}>
        <FaBell />
        {unread > 0 && <span className="notif-badge">{unread > 9 ? '9+' : unread}</span>}
      </button>

      {open && (
        <div className="notif-dropdown">
          <div className="notif-header">
            <span>Notifications</span>
            {unread > 0 && <button onClick={markAllRead}>Tout lire</button>}
          </div>
          <div className="notif-list">
            {notifications.length === 0 ? (
              <div className="notif-empty">Aucune notification</div>
            ) : notifications.map(n => (
              <div key={n.id} className={`notif-item ${n.is_read ? '' : 'unread'}`} onClick={() => !n.is_read && markRead(n.id)}>
                <span className="notif-icon">{typeIcons[n.type] || '🔔'}</span>
                <div className="notif-content">
                  <div className="notif-title">{n.title}</div>
                  {n.message && <div className="notif-message">{n.message}</div>}
                  <div className="notif-time">{formatDate(n.created_at)}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default NotificationBell;
